import React, { useContext, useEffect, useRef, useState } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import CustomerCardList from './CustomerCardList';
import { CardCvcElement, CardExpiryElement, CardNumberElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { PricingContext } from '../../Context/Pricing/PricingContext';
import * as Events from '../../Context/Pricing/Events';
import { SUBSCRIPTION_PLANS } from '../Shared/Subscription/SubscriptionInfo';
import SeatChangeInput from './SeatChangeInput';
import './stripe.css';
import moment from 'moment';
import DowngradeDialog from './DowngradeDialog';
import { addCustomerTaxId, getNewPrice, getNumberOfActiveProjects, getNumberOfSubscriptionUser, getPaymentMethodById, getProjectsWithUserCreateRoles, getSetupIntentClientSecret, getSubscriptionParameters, updateCustomer, updateCustomerDefaultPaymentMethod, updateNumberOfSeats, updateSubscriptionPrice } from '../../API/Payment/Payment';
import AddNewCardDialog from './AddNewCardDialog';
// import Skeleton from '../Shared/Skeleton/Skeleton';
import NewCardForm from './NewCardForm';
import BillingInformationForm from './BillingInformationForm';
import CompanyTaxInfoFields from './CompanyTaxInfoFields';
import OrderSummarySkeleton from './OrderSummarySkeleton';
import { callApiWithAuthorization } from '../../API/CallApi';
import CustomerCard from './CustomerCard';
import countriesList from '../Shared/CountriesList/CountriesList.json';
import PaymentLoader from './PaymentLoader';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { postMessageToRuntime } from '../Helpers/Runtime/runtime';

function PriceChangeConfirmationForm({ isAccessedFromRuntime = false }) {

    const { state, dispatch } = useContext(PricingContext)

    const elements = useElements();
    const stripe = useStripe();

    const formRef = useRef(null);
    const [loading, setLoading] = useState(false);

    const [cardNumberError, setCardNumberError] = useState("");
    const [cardExpiryError, setCardExpiryError] = useState("");
    const [cardCvcError, setCardCvcError] = useState("");
    const [showUpgradeMessage, setShowUpgradeMessage] = useState(false);
    const [showPaymentFailureError, setShowPaymentFailureError] = useState(false);

    useEffect(() => {
        const { selectedPlan, currentSubscription, subscriptions } = state;
        debugger
        // getSubscriptionParameters(selectedPlan.stripeProductId)
        //     .then(subscription => {
        const subscription = subscriptions.find(subscription => (
            subscription.stripeProductId === selectedPlan.stripeProductId
        ));
        dispatch({
            type: Events.SELECTED_SUBSCRIPTION_PARAMETERS_LOADED,
            payload: subscription
        })
        // })
    }, [state.selectedPlan])

    useEffect(() => {
        dispatch({ type: Events.NEW_PRICE_DATA_LOADING })
        getNewPriceData()
            .then(newPriceData => {
                debugger
                dispatch({
                    type: Events.NEW_PRICE_DATA_LOADED,
                    payload: newPriceData
                })
            })
    }, [state.numSeats, state.selectedPlan, state.interval])

    useEffect(() => {
        if (state.selectedPlan.name === "Free" && state.interval === "annually") {
            dispatch({
                type: Events.INTERVAL_CHANGED
            })
        }
        if (
            state.selectedPlan.name === "Free" &&
            state.numSeats !== 2
        ) {
            dispatch({
                type: Events.NUM_SEATS_CHANGED,
                payload: 2
            })
        } else if (
            state.selectedPlan.name !== "Free" &&
            state.numSeats === 2
        ) {
            dispatch({
                type: Events.NUM_SEATS_CHANGED,
                payload: 5
            })
        } else {
            const selectedSubscription = state.subscriptions.find(subscription => (
                subscription.stripeProductId === state.selectedPlan.stripeProductId
            ));
            if (state.numSeats > selectedSubscription.maxSeats) {
                dispatch({
                    type: Events.NUM_SEATS_CHANGED,
                    payload: selectedSubscription.maxSeats
                })
            }
        }
    }, [state.selectedPlan])

    async function getNewPriceData() {
        try {
            const { currentOrganization, numSeats, selectedPlan, interval } = state;
            const { stripePriceId } = selectedPlan.price[interval];
            const { stripeSubscriptionId } = currentOrganization;
            if (stripeSubscriptionId) {
                const price = await getNewPrice(stripeSubscriptionId, stripePriceId, numSeats);
                return price;
            }
            return {};
        } catch (e) {
            console.error(e);
        }
    }

    async function handleSubmit(event) {
        setLoading(true);
        setCardNumberError("");
        setCardCvcError("");
        event.target.disabled = true;
        try {
            if (state.numSeats > parseInt(state.selectedSubscriptionParameters.maxSeats)) {
                setLoading(false);
                return;
            }
            const userHasPaymentMethods = checkIfUserHasPaymentMethods();
            if (userHasPaymentMethods) {
                const userHasChangedPlan = checkForPlanChange();
                if (userHasChangedPlan) {
                    await handlePlanChange();
                    setLoading(false);
                    if (isAccessedFromRuntime) {
                        postMessageToRuntime({
                            designerStatus: "success"
                        })
                    }
                    return;
                }
                const userHasChangedSeats = checkForSeatsChange();
                if (userHasChangedSeats) {
                    const { currentOrganization, numSeats, selectedPaymentMethodId } = state;
                    await updateNumberOfSeats(
                        currentOrganization._id,
                        currentOrganization.stripeSubscriptionId,
                        numSeats,
                        selectedPaymentMethodId
                    )
                    dispatch({
                        type: Events.PRICE_CHANGE_SUCCESSFUL
                    })
                    setLoading(false);
                    if (isAccessedFromRuntime) {
                        postMessageToRuntime({
                            designerStatus: "success"
                        })
                    }
                    return;
                }
            } else {
                const { currentOrganization, interval, selectedPlan, numSeats } = state;
                const clientSecret = await getSetupIntentClientSecret(state.currentOrganization.stripeCustomerId);
                const { name, ...address } = state.billingInformation;
                let nameToUpdate = name;
                if (address.country === "CA") {
                    nameToUpdate = state.taxInfo.companyName;
                }
                const response = await stripe.confirmCardSetup(clientSecret, {
                    payment_method: {
                        card: elements.getElement(CardNumberElement),
                        billing_details: {
                            address,
                            name
                        }
                    }
                });
                try {
                    if (response.setupIntent) {
                        debugger;
                        await updateCustomerDefaultPaymentMethod(
                            currentOrganization._id,
                            response.setupIntent.payment_method
                        )
                        if (!state.currentOrganizationStripeData.address) {
                            await updateCustomer(
                                currentOrganization._id,
                                {
                                    address,
                                    stripeCustomerId: currentOrganization.stripeCustomerId
                                }
                            )
                        }
                        if (
                            state.currentOrganizationStripeData.tax_ids &&
                            state.currentOrganizationStripeData.tax_ids.data &&
                            state.currentOrganizationStripeData.tax_ids.data.length === 0 &&
                            state.taxInfo &&
                            state.taxInfo.gstNumber
                        ) {
                            await addCustomerTaxId(
                                state.currentOrganization._id,
                                state.taxInfo.gstNumber
                            )
                        }
                        await updateSubscriptionPrice(
                            currentOrganization._id,
                            currentOrganization.stripeSubscriptionId,
                            selectedPlan.price[interval].stripePriceId,
                            numSeats,
                            response.setupIntent.payment_method
                        )
                        dispatch({
                            type: Events.PRICE_CHANGE_SUCCESSFUL
                        })
                        if (isAccessedFromRuntime) {
                            postMessageToRuntime({
                                designerStatus: "success"
                            })
                        }
                    } else if (response.error) {
                        switch (response.error.code) {
                            case "expired_card":
                                setCardNumberError("Your card has expired.");
                                break;
                            case "incorrect_cvc":
                                setCardCvcError("Incorrect security code");
                                break;
                            case "processing_error":
                                setCardNumberError("An error occurred while processing your card. Try again in a little bit.");
                                break;
                            case "incorrect_number":
                                setCardNumberError("Your card number is incorrect.");
                                break;
                            default:
                                setCardNumberError(response.error.message);
                                break;
                        }
                    }
                } catch (error) {
                    if (error.message === "Your card was declined.") {
                        setShowPaymentFailureError(true);
                    } else {
                        console.error(error);
                    }
                    await callApiWithAuthorization("/api/v0/payment/method/" + response.setupIntent.payment_method, {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                }
            }
        } catch (e) {
            console.error(e);
        } finally {
            event.target.disabled = false;
            setLoading(false);
        }
    }

    async function handlePlanChange() {
        try {
            const userHasUpgraded = checkIfUserUpgraded();
            if (userHasUpgraded) {
                const { currentOrganization, interval, selectedPlan, selectedPaymentMethodId, numSeats } = state;
                await updateSubscriptionPrice(
                    currentOrganization._id,
                    currentOrganization.stripeSubscriptionId,
                    selectedPlan.price[interval].stripePriceId,
                    numSeats,
                    selectedPaymentMethodId
                )
                dispatch({
                    type: Events.PRICE_CHANGE_SUCCESSFUL
                })
            } else {
                dispatch({
                    type: Events.TOGGLE_DOWNGRADE_DIALOG
                })
            }
        } catch (e) {
            debugger
            if (e.message === "Your card was declined.") {
                setShowPaymentFailureError(true);
            } else {
                console.error(e);
            }
        }
    }

    function checkIfUserUpgraded() {
        try {
            const { currentSubscriptionStripeData, selectedPlan, interval } = state;
            const currentSubscriptionAmount = currentSubscriptionStripeData.items.data[0].price.unit_amount / 100;
            const currentSubscriptionInterval = currentSubscriptionStripeData.items.data[0].price.recurring.interval;
            const selectedSubscriptionAmount = selectedPlan.price[interval].amount;
            return (
                selectedSubscriptionAmount >= currentSubscriptionAmount ||
                currentSubscriptionInterval === "month" && interval === "yearly"
            );
        } catch (e) {
            console.error(e);
        }
    }

    function checkForSeatsChange() {
        try {
            const { currentSubscriptionStripeData, numSeats } = state;
            const previousSeatValue = currentSubscriptionStripeData.items.data[0].quantity;
            return previousSeatValue !== numSeats;
        } catch (e) {
            console.error(e);
        }
    }

    function checkIfUserHasPaymentMethods() {
        return state.paymentMethods.length > 0;
    }

    function checkForPlanChange() {
        try {
            const { currentSubscriptionStripeData, selectedPlan, interval } = state;
            const currentSubscriptionId = currentSubscriptionStripeData.items.data[0].price.id;
            const selectedSubscriptionId = selectedPlan.price[interval].stripePriceId;
            return currentSubscriptionId !== selectedSubscriptionId;
        } catch (e) {
            console.error(e);
        }
    }

    function getAmountDueToday() {
        const { currentSubscriptionStripeData, newPriceData } = state;
        const currentPriceId = currentSubscriptionStripeData && currentSubscriptionStripeData.items.data[0].price.id;
        const currentPriceQuantity = currentSubscriptionStripeData && currentSubscriptionStripeData.items.data[0].quantity;
        const newPriceId = newPriceData && newPriceData.lines ? newPriceData.lines.data[newPriceData.lines.data.length - 1].price.id : "";
        const newPriceQuantity = state.numSeats;
        if (
            currentSubscriptionStripeData &&
            currentPriceId === newPriceId &&
            currentPriceQuantity === newPriceQuantity
        ) {
            return 0;
        }
        return (
            (
                newPriceData &&
                newPriceData.amount_due &&
                newPriceData.amount_due / 100
            )
            ||
            0
        );
    }

    function getDaysLeftInCurrentSubscription() {
        try {
            const { currentSubscriptionStripeData } = state;
            const currentSubscriptionEndDate = currentSubscriptionStripeData.current_period_end * 1000;
            const currentDate = new Date();
            const daysLeft = Math.ceil((currentSubscriptionEndDate - currentDate) / (1000 * 60 * 60 * 24));
            return daysLeft;
        } catch (e) {
            console.error(e);
        }
    }

    function getRecurringTotal() {
        const { selectedPlan, interval, numSeats } = state;
        return (selectedPlan.price[interval].amount * (numSeats)).toFixed(2);
    }

    function getSavings() {
        try {
            const { numSeats } = state;
            if (numSeats < 0) {
                return 0;
            }
            const annualPrice = state.selectedPlan.price["annually"].amount;
            const monthlyPrice = state.selectedPlan.price["monthly"].amount;
            const annualPricePerMonth = annualPrice / 12;
            const finalAnnualPrice = state.selectedPlan.isDiscounted ? state.selectedPlan.getDiscountedPrice(annualPricePerMonth) : annualPricePerMonth;
            const finalMonthlyPrice = state.selectedPlan.isDiscounted ? state.selectedPlan.getDiscountedPrice(monthlyPrice) : monthlyPrice;
            const savings = parseInt(numSeats) * (finalMonthlyPrice - finalAnnualPrice) * 12;
            return savings;
        } catch (e) {
            console.error(e)
        }
    }

    async function handleDowngrade() {
        try {
            const seatsOverflow = await checkForSeatsOverflow();
            if (seatsOverflow) {
                dispatch({
                    type: Events.TOGGLE_SEAT_OVERFLOW_DIALOG
                })
                return;
            }
            const projectsOverflow = await checkForProjectOverflow();
            if (projectsOverflow) {
                dispatch({
                    type: Events.TOGGLE_PROJECT_OVERFLOW_DIALOG
                })
                return;
            }
            const rolesOverflow = await checkForRoleOverflow();
            if (rolesOverflow) {
                dispatch({
                    type: Events.TOGGLE_ROLE_OVERFLOW_DIALOG
                })
                return;
            }
            const { currentOrganization, interval, selectedPlan, selectedPaymentMethodId, numSeats } = state;
            await updateSubscriptionPrice(
                currentOrganization._id,
                currentOrganization.stripeSubscriptionId,
                selectedPlan.price[interval].stripePriceId,
                numSeats,
                selectedPaymentMethodId
            )
            dispatch({
                type: Events.PRICE_CHANGE_SUCCESSFUL
            })
        } catch (e) {
            console.error(e);
        }
    }

    async function checkForSeatsOverflow() {
        try {
            const { selectedSubscriptionParameters, currentOrganization } = state;
            const numberOfSubscriptionUser = await getNumberOfSubscriptionUser(currentOrganization._id);
            return (
                numberOfSubscriptionUser > parseInt(selectedSubscriptionParameters.maxSeats)
            );
        } catch (e) {
            console.error(e);
        }
    }

    async function checkForProjectOverflow() {
        try {
            const { _id } = state.currentOrganization;
            const numberOfActiveProjects = await getNumberOfActiveProjects(_id);
            dispatch({
                type: Events.NUM_ACTIVE_PROJECTS_LOADED,
                payload: numberOfActiveProjects
            });
            return numberOfActiveProjects > parseInt(state.selectedSubscriptionParameters.maxApps);
        } catch (e) {
            console.error(e);
        }
    }

    async function checkForRoleOverflow() {
        try {
            const { subscriptions, currentSubscription, selectedPlan } = state;
            const selectedSubscription = subscriptions.find(subscription => subscription.stripeProductId === selectedPlan.stripeProductId);
            if (selectedSubscription && selectedSubscription.rolesPermission !== "Full access" && currentSubscription.rolesPermission === "Full access") {
                const { _id } = state.currentOrganization;
                const projects = await getProjectsWithUserCreateRoles(_id);
                return projects.length > 0;
            }
            return false;
        } catch (e) {
            console.error(e);
        }
    }

    async function handleCardAdd(setupIntent) {
        try {
            const paymentMethod = await getPaymentMethodById(
                state.currentOrganization._id,
                setupIntent.payment_method
            );
            dispatch({
                type: Events.NEW_CARD_ADDED,
                payload: paymentMethod
            })
            dispatch({
                type: Events.TOGGLE_ADD_NEW_CARD_DIALOG
            })
        } catch (e) {
            console.error(e);
        }
    }

    function getAutoRenewalDate() {
        try {
            if (
                state.currentSubscriptionStripeData &&
                state.currentSubscriptionStripeData.current_period_end
            ) {
                const currentPrice = state.currentSubscriptionStripeData.items.data[0].price.unit_amount;
                const isIntervalUpgrade = state.interval === "annually" && state.currentSubscriptionStripeData.items.data[0].price.recurring.interval === "month";
                const isPriceUpgrade = state.selectedPlan.price[state.interval].amount > currentPrice;
                if (currentPrice === 0) {
                    const currentIntervalDate = state.newPriceData ? state.newPriceData.subscription_proration_date : new Date() / 1000;
                    if (state.interval === "monthly") {
                        return moment(currentIntervalDate * 1000).add(1, 'months').format('LL');
                    } else {
                        return moment(currentIntervalDate * 1000).add(1, 'years').format('LL');
                    }
                } else if (isIntervalUpgrade || isPriceUpgrade) {
                    return moment(state.newPriceData.subscription_proration_date * 1000).add(1, 'years').format('LL');
                }
                return moment(
                    new Date(state.currentSubscriptionStripeData.current_period_end * 1000)
                ).format('LL');
            }
            return "";
        } catch (e) {
            console.error();
        }
    }

    function getPlansToShow() {
        return SUBSCRIPTION_PLANS.filter(plan => plan.name !== "Free" && plan.name !== "Enterprise");
    }

    function isPaymentInformationValid() {
        const { paymentMethods, paymentInformationValid, billingInformation, taxInfo, selectedPaymentMethodId } = state;
        if (paymentMethods.length > 0 && selectedPaymentMethodId) {
            const selectedPaymentMethod = paymentMethods.find(paymentMethod => paymentMethod.id === selectedPaymentMethodId);
            return selectedPaymentMethod && !selectedPaymentMethod.isExpired;
        };
        const selectedCountry = countriesList.find(country => country.code === billingInformation.country);
        const countryHasStates = selectedCountry && selectedCountry.states && selectedCountry.states.length > 0;
        const billingInformationValid = (
            !!billingInformation.name?.trim() &&
            !!billingInformation.line1?.trim() &&
            (
                countryHasStates ? !!billingInformation.state?.trim() : true
            ) &&
            !!billingInformation.city?.trim() &&
            !!billingInformation.country?.trim() &&
            !!billingInformation.postal_code?.trim()
        );
        const taxInfoValid = taxInfo.isCompany ? (
            !!taxInfo.companyName?.trim() &&
            !!taxInfo.gstNumber?.trim() &&
            /[0-9]{9}(RC|RM|RP|RT)[0-9]{4}/g.test(taxInfo.gstNumber) &&
            taxInfo.gstNumber.length === 15
        ) : true;
        return paymentInformationValid && billingInformationValid && taxInfoValid;
    }

    function isSeatsValid() {
        const { numSeats, subscriptions } = state;
        const selectedSubscription = subscriptions.find(subscription => (
            subscription.stripeProductId === state.selectedPlan.stripeProductId
        ));
        if (selectedSubscription) {
            if (selectedSubscription.stripeProductId === process.env.REACT_APP_STRIPE_FREE_PRODUCT_ID) {
                return numSeats !== 2;
            }
            return numSeats < 5 || numSeats > parseInt(selectedSubscription.maxSeats);
        }
        return false;
    }

    function isPlanDowngrade() {
        const { currentSubscriptionStripeData } = state;
        const productId = currentSubscriptionStripeData.plan.product;
        const selectedProductId = state.selectedPlan.stripeProductId;
        return (
            (
                productId === process.env.REACT_APP_STRIPE_PRO_PRODUCT_ID &&
                selectedProductId === process.env.REACT_APP_STRIPE_STARTER_PRODUCT_ID
            ) ||
            (
                productId === process.env.REACT_APP_STRIPE_STARTER_PRODUCT_ID &&
                selectedProductId === process.env.REACT_APP_STRIPE_FREE_PRODUCT_ID
            )
        )
    }

    return (
        <div>
            {
                state.showDowngradeDialog &&
                <DowngradeDialog
                    oldPlanName={state.currentSubscription.subscriptionName}
                    oldPlanInterval={
                        state.currentSubscriptionStripeData.items.data[0].price.recurring.interval === "month" ?
                            "Monthly" : "Annual"
                    }
                    oldSeats={state.currentSubscriptionStripeData.items.data[0].quantity}
                    nextPlanName={state.selectedPlan.name}
                    nextPlanInterval={state.interval === "monthly" ? "Monthly" : "Annual"}
                    nextSeats={state.numSeats}
                    planEndDate={getAutoRenewalDate()}
                    isPlanDowngrade={isPlanDowngrade()}
                    onClose={() => {
                        dispatch({ type: Events.TOGGLE_DOWNGRADE_DIALOG })
                    }}
                    onConfirm={handleDowngrade} />
            }
            {
                state.showAddNewCardDialog &&
                <AddNewCardDialog
                    organizationId={state.currentOrganization._id}
                    customerId={state.currentOrganization.stripeCustomerId}
                    onCreate={handleCardAdd}
                    onClose={() => {
                        dispatch({
                            type: Events.TOGGLE_ADD_NEW_CARD_DIALOG
                        })
                    }} />
            }
           <div className={loading? "disable-screen": ""}>
           <div className='row mt-2 gx-5 w-100'>
                <div className='col-12 mb-3 ms-1 price-plan'>
                    <button className='btn ms-5 ps-5' data-testid="back" onClick={() => {
                        dispatch({
                            type: Events.PRICE_SELECTED,
                            payload: null
                        })
                    }}>
                        <span className='chevron'>
                            <i 
                            className="fa-thin fa-chevron-left"></i></span>
                        &nbsp;&nbsp;
                        <span className="pt-1 ps-1 font-size-4">
                            Pricing Plans
                        </span>
                    </button>
                </div>
                <div className="d-flex justify-content-spacing price-color ms-4 pb-5">
                <div className='price-bg p-4'>
                    <div className='row subscription'>
                        <div className='col-12'>
                            <h4 className='f-header'>Subscription Details</h4>
                        </div>
                        <div className='col-12'>
                            <label className='form-label' id="plan-dropdown-label">
                                Subscription Plan
                            </label>
                            <DropDownList
                                ariaLabelledBy='plan-dropdown-label'
                                data={getPlansToShow()}
                                value={state.selectedPlan}
                                textField="name"
                                dataItemKey='stripeProductId'
                                onChange={(e) => {
                                    dispatch({
                                        type: Events.PRICE_SELECTED,
                                        payload: e.value
                                    })
                                }}
                            />
                        </div>
                        <div className='col-12 num font-size-1'>
                            <Tooltip position="right" anchorElement="target">
                                <label htmlFor='num-seats-input' className='form-label'>
                                    Number of Seats &nbsp;
                                    <i
                                        className='fa-solid fa-info-circle'
                                        title="Total number of seats you will have after confirmation." />
                                </label>
                            </Tooltip>
                            <SeatChangeInput
                                disabled={state.selectedPlan.name === "Free"}
                                numberOfSeats={parseInt(state.numSeats)}
                                minSeats={5}
                                maxSeats={parseInt(state.selectedSubscriptionParameters.maxSeats)}
                                setShowUpgradeMessage={setShowUpgradeMessage}
                                onChange={(value) => {
                                    dispatch({
                                        type: Events.NUM_SEATS_CHANGED,
                                        payload: value
                                    })
                                }} />
                            {
                                showUpgradeMessage &&
                                <div className='px-3 py-4 mt-3 highlighted-left-orange-border-alert shadow'>
                                    {
                                        state.selectedPlan.name === "Starter" ?
                                            <p className='mb-0'>
                                                Upgrade to <b>Pro</b> to get { state.selectedSubscriptionParameters.maxSeats }+ seats
                                            </p>
                                            :
                                            <p className='mb-0'>
                                                For 100+ seats, contact our <a href='https://www.codelessone.com/contact-us/' target='_blank'>sales team.</a> 
                                            </p>
                                    }
                                </div>
                            }
                        </div>
                        <div className='col-12'>
                            <div className='row gap-2 justify-content-center mt-3'>
                                <div className='col-12'>
                                    <hr />
                                </div>
                                <div
                                    data-testid="monthly-price"
                                    className={
                                        `col-5 ${state.interval === "monthly" ? "border-primary card-selected" : "border"} rounded d-flex flex-column text-center align-items-center justify-content-center p-5 mt-3 mb-4`
                                    }
                                    onClick={() => {
                                        if (state.interval === "annually") {
                                            dispatch({
                                                type: Events.INTERVAL_CHANGED
                                            })
                                        }
                                    }}>
                                    <div>
                                        <h5>Monthly</h5>
                                    </div>
                                    <div>
                                        <h3>${state.selectedPlan.price.monthly.amount}</h3>
                                    </div>
                                    <div className='price-color'>
                                        <p className='text-muted'>/User /Month</p>
                                        <p className='text-muted mb-0'>Billed Monthly</p>
                                    </div>
                                    </div>
                                {
                                    state.selectedPlan.name !== "Free" ?
                                    <div
                                        data-testid="annual-price"
                                        className={
                                            `col-5 ${state.interval === "annually" ? "border-primary card-selected" : "border"} rounded d-flex flex-column text-center align-items-center justify-content-center p-5 mt-3 mb-4`
                                        }
                                        onClick={() => {
                                            if (state.interval === "monthly") {
                                                dispatch({
                                                    type: Events.INTERVAL_CHANGED
                                                })
                                            }
                                        }}>

                                        <div className='card-title-free'>
                                        2 months free
                                        </div>
                                        <div>
                                            <h5>Annual</h5>
                                        </div>
                                        <div>
                                            <h3>${state.selectedPlan.price.annually.amount / 12}</h3>
                                        </div>
                                        <div>
                                            <p className='text-muted'>/User /Month</p>
                                            <p className='text-muted mb-0'>Billed Annually</p>
                                        </div>
                                        </div>
                                        :
                                    <div className='col-5'></div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className='price-bg p-4'>
                    <div className='col-12'>
                        <h4 className='f-header'>Payment Method</h4>
                    </div>
                    {
                        state.paymentMethods.length === 0 &&
                        <div className='row' data-testid="add-card-form">
                            <NewCardForm
                                onChange={({ valid }) => {
                                    dispatch({
                                        type: Events.PAYMENT_INFORMATION_VALID_STATE_CHANGED,
                                        payload: valid
                                    })
                                }}
                                errors={{
                                    cardNumberError,
                                    cardExpiryError,
                                    cardCvcError
                                }}
                            />
                            <BillingInformationForm
                                showErrors={true}
                                onChange={value => dispatch({
                                    type: Events.SET_BILLING_INFORMATION,
                                    payload: value
                                })} />
                            {
                                state.billingInformation.country === "CA" &&
                                <CompanyTaxInfoFields
                                    showErrors={true}
                                    onChange={value => dispatch({
                                        type: Events.SET_TAX_INFO,
                                        payload: value
                                    })} />
                            }
                            
                        </div>
                    }
                    <div className='col-12'>
                        <CustomerCardList
                            organizationId={state.currentOrganization._id}
                            CardItem={CustomerCard} />
                        {
                            state.paymentMethods.length > 0 &&
                            <button className='btn btn-link font-size-1' onClick={() => {
                                dispatch({
                                    type: Events.TOGGLE_ADD_NEW_CARD_DIALOG
                                })
                            }}>
                                <i className='fa-solid fa-plus' /> Add card
                            </button>
                        }
                    </div>
                </div>
                <div className='price-bg p-4'>
                    <h4 className='f-header'>
                        Order Summary
                        {
                            showPaymentFailureError &&
                            <span className='text-danger'>
                                &nbsp;Your card was declined.
                            </span>
                        }
                    </h4> 

                            {loading && <PaymentLoader />}

                            {
                                state.loadingNewPriceData ?
                                    <OrderSummarySkeleton />
                                    :
                                    <>
                                        <div className='row lh-28 font-size-1'>
                                            <div className='col-12'>
                                                <p className='mb-0'>
                                                    Subscribe to{" "}
                                                    <b>{state.selectedPlan.name} - {state.interval === "annually" ? "Annual" : "Monthly"}</b>{" "}
                                                    Plan
                                                </p>
                                            </div>
                                            {
                                                state.interval === "annually" &&
                                                <>
                                                    <div className='col-8'>
                                                        <b className='annual-save'>Annual Savings</b>
                                                    </div>
                                                    <div className='col-4'>
                                                        <b className='annual-save float-right'>USD ${getSavings()}</b>
                                                    </div>
                                                </>
                                            }
                                            <div className='col-8 py-3'>
                                                <b>Amount due today</b>
                                            </div>
                                            <div className='col-4 py-3'>
                                                <b className='float-right'>
                                                    USD ${getAmountDueToday()}
                                                </b>
                                            </div>

                                            <div className='col-12'>
                                                <div className='row'>
                                                    <div className='col-8'>
                                                        Renewal total
                                                    </div>
                                                    <div className='col-4'>
                                                        <b className='float-right'>USD ${getRecurringTotal()}</b>
                                                    </div>
                                                    <div className='col-12'>
                                                        Auto-renewal on {getAutoRenewalDate()}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-12 mt-2'>
                                                <button
                                                    onClick={handleSubmit}
                                                    className='btn btn-clr w-100'
                                                    disabled={
                                                        !isPaymentInformationValid() ||
                                                        isSeatsValid()
                                                    }
                                                >
                                                    Confirm and Pay
                                                </button>
                                            </div>

                                        </div>
                                        <div className='col-12 my-3'>
                                            By Clicking "Confirm and Pay" you agree to the <a href='#'>Terms and Conditions.</a>
                                        </div>
                                        <div className="border-top">
                                            <div className="row mt-3">

                                                <div className="col-5 align-self-center"> <i className="fa-solid fa-lock me-1"></i> Secure Checkout</div>
                                                {/* <div className='col-7 d-flex text-center text-secure font-size-5'>
                                <div>
                                    <div>
                                        <i className='fa-solid fa-shield  p-1 border-secure rounded-circle' />
                                    </div>
                                    <span >
                                    SSL Protected
                                    </span>
                                </div>
                                <div className="mx-4">
                                    <div>
                                        <i className='fa-solid fa-globe p-1 border-secure rounded-circle' />
                                    </div>
                                    <span>
                                        PCI Compliant
                                    </span>
                                </div>
                                <div>
                                    <div>
                                        <i className='fa-brands fa-expeditedssl  p-1 border-secure rounded-circle' />
                                    </div>
                                    <span>
                                        Encrypted
                                    </span>
                                </div>
                            </div> */}
                                            </div>
                                        </div>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PriceChangeConfirmationForm;